import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchProductionItemIssueData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/productionItemIssue/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('setProductionItemIssueData', {response: res.data.response})   
        } 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitProductionItemIssueData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionItemIssue/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            //dispatch('fetchProductionItemIssueData', {id: res.data.id})
            commit('setProductionItemIssueID', {id: res.data.id, challan_number: res.data.challan_number})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteProductionItemIssueData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionItemIssue/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchProductionItemIssueList', {store_list: payload.store_list})
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/productionItemIssue/actions.js